import * as Icon from "lucide-react";

const IconComponent = ({type}) => {
    const Component = Icon[type]
    return <Component size={16}/>;
}

export default IconComponent